

export default {
    methods: {
        demoLogin(type){
            this.$router.push({name : "login", query: { demo: type }});
        }
    },
};